import type { ViewStyle, ImageStyle, TextStyle, Animated } from "react-native";

export function createAnimationFromObject(
  config: {
    from: ViewStyle & ImageStyle & TextStyle;
    to: ViewStyle & ImageStyle & TextStyle;
  },
  animated: Animated.Value,
  inputRange: [number, number]
): Animated.AnimatedProps<ViewStyle & ImageStyle & TextStyle> {
  const styles: Animated.AnimatedProps<ViewStyle & ImageStyle & TextStyle> = {};
  const createInterpolatedValue = (
    outputRange: [number, number] | [string, string]
  ) => {
    return animated.interpolate({
      inputRange,
      outputRange,
    });
  };

  Object.keys(config.from as any).forEach((key) => {
    if (!(config.to as any)[key]) {
      throw new Error(
        "animation must be animating the same properties for both from and to"
      );
    }

    switch (key) {
      case "transform":
        if (
          !(config.from as any)[key].every((obj: Record<string, any>) => {
            return Object.keys(obj).length === 1;
          })
        ) {
          throw new Error(
            "transforms can only have one property per transform"
          );
        }

        if (
          !(config.from as any)[key]
            .map((obj: Record<string, any>) => Object.keys(obj))
            .flat()
            .every((mapKey: string) => {
              return (config.to as any)[key]
                .map((obj: Record<string, any>) => Object.keys(obj))
                .flat()
                .includes(mapKey);
            })
        ) {
          throw new Error(
            "animation must be animating the same properties for both from and to (all transforms must match)"
          );
        }

        (config.from as any)[key].forEach(
          (transformObject: Record<string, any>, transformIndex: number) => {
            (styles as any)[key] = Object.keys(transformObject).map(
              (transformKey) => {
                return {
                  [transformKey]: createInterpolatedValue([
                    (config.from as any)[key][transformIndex][transformKey],
                    (config.to as any)[key][transformIndex][transformKey],
                  ]),
                };
              }
            );
          }
        );

        break;

      default:
        (styles as any)[key] = createInterpolatedValue([
          (config.from as any)[key],
          (config.to as any)[key],
        ]);

        break;
    }
  });

  return styles;
}
